<div
  role="progressbar"
  aria-valuemin="0"
  [attr.aria-valuenow]="strength"
  aria-valuemax="100"
  class="ui-progressbar ui-widget ui-widget-content ui-corner-all ui-progressbar-determinate"
>
  <div
    class="ui-progressbar-value ui-progressbar-value-animate ui-widget-header ui-corner-all"
    style="display: block"
    [style.width]="strength + '%'"
    [style.backgroundColor]="color"
  ></div>
  <div class="ui-progressbar-label" style="display: block !important">{{ label }}</div>
</div>
